import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { SelectControl, SelectItem } from 'src/app/form-controls/select/select.control';
import { TextAreaControl } from 'src/app/form-controls/textarea/textarea.control';
import { SheetItemService } from 'src/app/services/sheet-item.service';
import { ItemTypeMetadata, SheetItemFormBase } from 'src/app/services/sheets-renderer.service';
import { Row } from 'src/app/types/aggregate-graph.types';
import { SkincareInstruction, SkincareLevel } from 'src/app/types/sheet-instruction.types';
import { InstructionsFormComponent } from '../../instructions-form/instructions-form.component';

interface SkincareInstructionFormGroup {
	area: FormControl<string | null>;
	skincareLevel: FormControl<SkincareLevel | null>;
}

@Component({
    selector: 'app-skincare-item-form',
    templateUrl: './skincare-item-form.component.html',
    styleUrl: './skincare-item-form.component.scss',
    imports: [ReactiveFormsModule, InstructionsFormComponent, TextAreaControl, SelectControl],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SkincareItemFormComponent implements SheetItemFormBase, OnInit {

	@Input() instructionTypeName!: string;
	@Input() item!: Row | null;
	@Input() minDate!: string;
	@Input() maxDate!: string;
	@Input() instructionsFormArray!: FormArray;
	@Input() itemConfig!: ItemTypeMetadata;

	skincareLevels: SelectItem[] = [
		{ text: 'IAD skin care preventative', value: SkincareLevel.Preventative },
		{ text: 'IAD skin care category 1', value: SkincareLevel.One },
		{ text: 'IAD skin care category 2', value: SkincareLevel.Two },
		{ text: 'IAD skin care category 3', value: SkincareLevel.Three },
	];


	constructor(private sheetItemService: SheetItemService, private formBuilder: FormBuilder) {
	}

	ngOnInit() {
		this.sheetItemService.getInstructions(this.item, this.instructionTypeName, this.itemConfig.scheduleConfig.defaultScheduleType, this.itemConfig.scheduleConfig.defaultRepeatingScheduleFrequency).forEach(instruction => {
			const group: FormGroup<SkincareInstructionFormGroup> = this.sheetItemService.buildExistingInstructionGroup(this.instructionTypeName, instruction);
			const skincareInstruction = instruction as SkincareInstruction;
			group.addControl('area', this.formBuilder.control(skincareInstruction.area ?? null));
			group.addControl('skincareLevel', this.formBuilder.control(skincareInstruction.skincareLevel ?? null));
			this.instructionsFormArray.push(group);
		});
	}

	addInstruction() {
		const group: FormGroup<SkincareInstructionFormGroup> = this.sheetItemService.getNewInstructionGroup(this.instructionTypeName, this.itemConfig.scheduleConfig.defaultScheduleType, this.itemConfig.scheduleConfig.defaultRepeatingScheduleFrequency);
		group.addControl('area', this.formBuilder.control(null));
		group.addControl('skincareLevel', this.formBuilder.control(null));
		this.instructionsFormArray.push(group);
	}
}